export default "__VITE_ASSET__CsfC4twF__"